import { Claim } from './claim'

export class UserClaims {
    claims: Claim[]
    userIds: number[]
}
